import AboutUs from "pages/AboutUs";
import Banners from "pages/Banners";
import Brands from "pages/Brands";
import ExclusiveBrands from "pages/ExclusiveBrands";
import Languages from "pages/Languages";
import Login from "pages/Login/Login";
import Setting from "pages/Setting";
import { ReactElement } from "react";
import { Navigate } from "react-router-dom";
import { routeVariables } from "./routeVariables";
import ProjectCategories from "pages/ProjectCategories";
import Projects from "pages/Projects";
import Admins from "pages/Admins";
import ContactUs from "pages/ContactUs";
import Faqs from "pages/Faqs";
import Blogs from "pages/Blogs";
import BlogCategories from "pages/BlogCategories";
interface RouteConfig {
  path: string;
  element: ReactElement;
  requiresAuth?: boolean;
  permissions?: string[];
  exact?: boolean;
}

export const routesConfig: RouteConfig[] = [
  { path: "/", element: <Navigate to={routeVariables.main} /> },
  { path: routeVariables.login, element: <Login /> },
  {
    path: routeVariables.admins.all,
    element: <Admins />,
    requiresAuth: true,
    permissions: ["read:user", "maintain:user"],
  },
  {
    path: routeVariables.brands.all,
    element: <Brands />,
    requiresAuth: true,
    permissions: ["read:brands", "maintain:brands"],
  },
  {
    path: routeVariables.faqs.all,
    element: <Faqs />,
    requiresAuth: true,
    permissions: ["read:faqs", "maintain:faqs"],
  },
  {
    path: routeVariables.blogs.all,
    element: <Blogs />,
    requiresAuth: true,
    permissions: ["read:blogs", "maintain:blogs"],
  },
  {
    path: routeVariables.projects.all,
    element: <Projects />,
    requiresAuth: true,
    permissions: ["read:projects", "maintain:projects"],
  },
  {
    path: routeVariables.projectCategories.all,
    element: <ProjectCategories />,
    requiresAuth: true,
    permissions: ["read:project-categories", "maintain:project-categories"],
  },
  {
    path: routeVariables.blogCategories.all,
    element: <BlogCategories />,
    requiresAuth: true,
    permissions: ["read:blog-categories", "maintain:blog-categories"],
  },
  {
    path: routeVariables.contactUs.all,
    element: <ContactUs />,
    requiresAuth: true,
    permissions: ["read:contact-us", "maintain:contact-us"],
  },

  {
    path: routeVariables.languages.all,
    element: <Languages />,
    requiresAuth: true,
    permissions: ["read:languages", "maintain:languages"],
  },
];
